import React, { useState, useRef, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { DatePicker } from "rsuite";
import {
  createAndUpdateFaqs,
  createPackageType,
  createPlayerSubscription,
  getFaqCategories,
  getFaqs,
  getPackageDuration,
  getPackageType,
  getPackageTypeEnum,
  getPlayerSubscription,
} from "../../../services/academicService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CategoryScale } from "chart.js";

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Category", sortingVale: "category" },
  { heading: "Question", sortingVale: "question" },
  { heading: "Answer", sortingVale: "answer" },
  { heading: "Actions", sortingVale: "actions" },
];

const AllFaqs = () => {
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [subscription, setSubscription] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedPackageTime, setSelectedPackageTime] = useState(null);
  const [selectedPackageEnum, setSelectedPackageEnum] = useState(null);
  const [faqCategories, setFaqCategories] = useState([]);
  const [formData, setFormData] = useState({
    question: "",
    answer: "",
    category: "",
  });

  function SotingData(name) {
    const sortedPeople = [...subscription];
    switch (name) {
      case "packageType":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.packageType.localeCompare(b.packageType)
            : b.packageType.localeCompare(a.packageType);
        });
        break;

      case "description":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.description.localeCompare(b.description)
            : b.description.localeCompare(a.description);
        });
        break;

      default:
        break;
    }
    setSubscription(sortedPeople);
  }

  function DataSearch(e) {
    const updatesDate = subscription.filter((item) => {
      let selectdata = `${item.name} `.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setSubscription([...updatesDate]);
  }

  const validate = () => {
    const newErrors = {};

    if (!formData.question || !formData.question.trim())
      newErrors.question = "Question is required";
    if (!formData.answer || !formData.answer.trim())
      newErrors.answer = "Answer is required";
    if (!selectedPackageEnum)
      newErrors.category = "Category selection is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // return true if no errors
  };

  useEffect(() => {
    fetchFaqs();
    fetchCategory();
  }, []);

  async function fetchFaqs() {
    try {
      const res = await getFaqs();
      setSubscription(res);
    } catch (error) {
      console.error("Error fetching FAQ data:", error);
    }
  }

  async function fetchCategory() {
    try {
      const res = await getFaqCategories();
      setFaqCategories(res);
    } catch (error) {
      console.error("Error fetching FAQ categories:", error);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    const payload = {
      question: formData.question,
      answer: formData.answer,
      faqCategoryId: selectedPackageEnum?.value,
    };

    // If editing, include id
    if (editingId) {
      payload.id = editingId;
    }

    try {
      const res = await createAndUpdateFaqs(payload);
      if (res) {
        toast.success(
          editingId ? "Updated FAQ successfully!" : "Created FAQ successfully!",
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        fetchFaqs();
        handleCancel();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCancel = () => {
    setFormData({
      question: "",
      answer: "",
    });

    setSelectedPackageEnum(null);
    setEditingId(null);
    setErrors({});
  };

  return (
    <>
      <PageTitle activeMenu={"All FAQs"} motherMenu={"FAQs"} />
      <div className="row">
        <div className="col-xl-12 col-xxl-12 col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                FAQ {editingId ? "Updation" : "Creation"}
              </h5>
            </div>

            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="question">
                        Question <span className="required">*</span>
                      </label>
                      <input
                        id="question"
                        name="question"
                        placeholder="Enter Question"
                        type="text"
                        className={`form-control ${
                          errors.question ? "is-invalid" : ""
                        }`}
                        value={formData.question}
                        onChange={handleChange}
                        required
                      />
                      {errors.question && (
                        <small className="text-danger m-lg-2">
                          {errors.question}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="category">
                        Category <span className="required">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        value={selectedPackageEnum}
                        options={
                          faqCategories?.map((fc) => ({
                            value: fc?.id,
                            label: fc?.name,
                          })) || []
                        }
                        onChange={(d) => {
                          setSelectedPackageEnum(d);
                          setErrors((prev) => ({
                            ...prev,
                            category: "",
                          }));
                        }}
                        placeholder="Select Category"
                        className="custom-react-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.category
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.category
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.category
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.category && (
                        <small className="text-danger m-lg-2">
                          {errors.category}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="answer">
                        Answer <span className="required">*</span>
                      </label>
                      <textarea
                        id="answer"
                        name="answer"
                        placeholder="Enter your Answer"
                        className={`form-control ${
                          errors.answer ? "is-invalid" : ""
                        }`}
                        rows="4"
                        value={formData.answer}
                        onChange={handleChange}
                      />
                      {errors.answer && (
                        <small className="text-danger m-lg-2">
                          {errors.answer}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="submit"
                      className="btn btn-primary me-1"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading
                        ? editingId
                          ? "Updating..."
                          : "Submitting..."
                        : editingId
                        ? "Update"
                        : "Submit"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger light"
                      onClick={handleCancel}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            {/* <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav> */}
          </div>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">FAQ List</h4>
                    {/* <button
                      onClick={() => setVisible(true)}
                      className="btn btn-primary"
                    >
                      + Add New
                    </button> */}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="holidayList"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="justify-content-between d-sm-flex">
                          <div className="dataTables_length"></div>
                          <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                onChange={DataSearch}
                              />
                            </label>
                          </div>
                        </div>
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                >
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i
                                        className="fa fa-sort ms-2 fs-12"
                                        style={{ opacity: "0.3" }}
                                      />
                                    )}
                                    {ind === iconData.ind &&
                                      (iconData.complete ? (
                                        <i
                                          className="fa fa-arrow-down ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-arrow-up ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ))}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {subscription?.map((data, ind) => (
                              <tr key={ind}>
                                <td>{ind + 1}</td>
                                <td>{data?.faqCategory?.name}</td>
                                <td>{data?.question}</td>
                                <td>{data?.answer}</td>

                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-s sharp btn-primary me-1"
                                    onClick={() => {
                                      setEditingId(data.id);

                                      setFormData({
                                        question: data.question || "",
                                        answer: data.answer || "",
                                      });

                                      setSelectedPackageEnum({
                                        value: data?.faqCategory?.id,
                                        label: data?.faqCategory?.name,
                                      });

                                      setErrors({});
                                    }}
                                  >
                                    <i className="fa fa-pencil" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
    </>
  );
};

export default AllFaqs;
